import { Page } from '../../types'
import { getEnvParameters } from '../shared/env'
import { getParamsDict } from './util'

type TricksPuLPProps = { 
    license: string|null
}

const selfManage = (paramDict: string|null) => 
`import gurobipy as gp
import pulp as pl

${paramDict}

with gp.Env(params=params) as env:
    # Pass environment as a parameter
    solver = pl.GUROBI(env=env)
    prob.solve(solver)
    solver.close() # dispose the model
`

const pulpManage = (paramDict: string|null) => 
`import pulp as pl

${paramDict}

solver = pl.GUROBI(manageEnv=True, envOptions=params)
prob.solve(solver) 
solver.close()`

const render = ({ license }: TricksPuLPProps)  => {
    let customizeEnv = null
    if(license !== null)
    {
        const env = getEnvParameters(license)
        const dict = getParamsDict(env?.parameters)
        customizeEnv = (<><h3>Customizing the Gurobi environment</h3>
            <p>
                From PuLP v2.8.0 you can use gurobipy environments via the use of the parameters <code>env</code> or <code>manageEnv</code>.
                The difference is related to who is responsible for managing the Gurobi environment.
                <ul>
                    <li>
                        <h4>Managing the environment in your own code</h4>
                        <pre>{selfManage(dict)}</pre>                
                    </li>
                    <li>
                        <h4>Letting PuLP manage the environment</h4>
                        <pre>{pulpManage(dict)}</pre>                
                    </li>
                </ul>
            </p></>)
    } 
    return <>        
    <h3>Exporting a model</h3>
    <p>
        You can simply export a model using <code>model.writeLP(filename)</code>
        or <code>model.writeMPS(filename)</code>. PuLP does not support anonymizing your 
        variable and constraint names when saving the model.
    </p>
    {customizeEnv}
    <h3>Setting model parameters</h3>
    <p>
        You can set Gurobi parameters when solving your model, by passing them as arguments
        to the creation of the Gurobi solver: <code>prob.solve(solver=GUROBI(MIPGap=0.5))</code>
    </p>    
    <h3>Accessing gurobipy functionality</h3>
    <p>
        PuLP is an abstraction layer over gurobipy and does not expose all functionality.
        However, you can still acccess the underlying gurobipy <code>Model</code> object
        by accessing <code>prob.solverModel</code>:
        <pre>
            from pulp import *<br/>
            prob = LpProblem("Problem name", LpMinimize)<br/>
            prob.solve(solver=GUROBI())<br/>
            model = prob.solverModel<br/>
            model.computeIIS()
        </pre>
    </p>        
    <h3>Disposing your environment</h3>
    <p>
        The only way to explicitly dispose your environment and release any
        WLS or Token Server tokens, is as follows:
        <pre>
            prob.solverModel.dispose()
            import gurobipy as gp
            gp.disposeDefaultEnv()
        </pre>
    </p>
    </>
}

const TricksPuLP : Page<TricksPuLPProps> = { title: 'Tips and tricks for PuLP', key: 'tricks-pulp', render }

export default TricksPuLP